import moment from 'moment';
import { pathOr } from 'ramda';
import request from '@utils/request';
import { parseDateToString, ONE_DAY_IN_MS } from '@utils/helpers';
import { JourneyParams } from 'shared-types/Common';

const PREFIX = '[RATES]';

export const GET_RATES_REQUEST = `${PREFIX} GET_RATES_REQUEST`;
export const GET_RATES_SUCCESS = `${PREFIX} GET_RATES_SUCCESS`;
export const GET_RATES_FAILURE = `${PREFIX} GET_RATES_FAILURE`;

export const getRatesRequest = () => ({
  type: GET_RATES_REQUEST,
});

export const getRatesSuccess = (payload) => ({
  type: GET_RATES_SUCCESS,
  payload,
});

export const getRatesFailure = (payload) => ({
  type: GET_RATES_FAILURE,
  payload,
});

export const getRates =
  (
    propertyId,
    {
      fromDate = moment(new Date()),
      toDate = moment(new Date(new Date().getTime() + ONE_DAY_IN_MS)),
      adults = 2,
      children = 0,
      promoRateCode,
    }: JourneyParams,
    rateCode
  ) =>
  (dispatch) => {
    dispatch(getRatesRequest());

    return request
      .get(`${propertyId}/rates`, {
        params: {
          'from-date': parseDateToString(fromDate),
          'to-date': parseDateToString(toDate),
          adults,
          children,
          promoRateCode,
          rateCode,
        },
      })
      .then(
        ({ data }) => dispatch(getRatesSuccess(data)),
        (error) => {
          console.error(error);
          dispatch(getRatesFailure(error));
        }
      );
  };

const getRate =
  (requestAction, successAction, failureAction) =>
  (
    propertyId,
    rateId,
    {
      fromDate = moment(new Date()),
      toDate = moment(new Date(new Date().getTime() + ONE_DAY_IN_MS)),
      adults = 2,
      children = 0,
    }
  ) =>
  (dispatch) => {
    dispatch(requestAction());

    return request
      .get(`${propertyId}/rates/${rateId}`, {
        params: {
          'from-date': parseDateToString(fromDate),
          'to-date': parseDateToString(toDate),
          adults,
          children,
        },
      })
      .then(
        ({ data }) => dispatch(successAction(data)),
        (error) => {
          console.error(error);
          dispatch(failureAction(error));
        }
      );
  };

export const GET_SINGLE_RATE_REQUEST = `${PREFIX} GET_SINGLE_RATE_REQUEST`;
export const GET_SINGLE_RATE_SUCCESS = `${PREFIX} GET_SINGLE_RATE_SUCCESS`;
export const GET_SINGLE_RATE_FAILURE = `${PREFIX} GET_SINGLE_RATE_FAILURE`;

const getSingleRateRequest = () => ({
  type: GET_SINGLE_RATE_REQUEST,
});

const getSingleRateSuccess = (payload) => ({
  type: GET_SINGLE_RATE_SUCCESS,
  payload,
});

const getSingleRateFailure = () => ({
  type: GET_SINGLE_RATE_FAILURE,
});

export const getSingleRate = getRate(
  getSingleRateRequest,
  getSingleRateSuccess,
  getSingleRateFailure
);

export const GET_RATE_ROOMS_REQUEST = `${PREFIX} GET_RATE_ROOMS_REQUEST`;
export const GET_RATE_ROOMS_SUCCESS = `${PREFIX} GET_RATE_ROOMS_SUCCESS`;
export const GET_RATE_ROOMS_FAILURE = `${PREFIX} GET_RATE_ROOMS_FAILURE`;

const getRateRoomsRequest = () => ({
  type: GET_RATE_ROOMS_REQUEST,
});

const getRateRoomsSuccess = (data) => ({
  type: GET_RATE_ROOMS_SUCCESS,
  payload: pathOr([], ['rooms'], data),
});

const getRateRoomsFailue = (payload) => ({
  type: GET_RATE_ROOMS_FAILURE,
  payload,
});

export const getRateRooms = getRate(getRateRoomsRequest, getRateRoomsSuccess, getRateRoomsFailue);
